import 'react-app-polyfill/ie11'; // For IE11 support
import 'react-app-polyfill/stable'; // For other browsers
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import AddCreditCard, { IAddCreditCardProps } from "./AddCreditCard";
import reportWebVitals from "./reportWebVitals";
import Health from "./Health";
import CheckoutErrorPage from "./CheckoutErrorPage";
import HandleRedirectPaymentChallenge from './HandleRedirectPaymentChallenge';
import RdsConsentPage, { IRdsConsentPageProps } from "./RdsConsentPage";
import DeviceFingerprintPage, { IDeviceFingerprintPageProps } from "./DeviceFingerprintPage";
import $ from "jquery";

const environment = getEnvironmentFromUrl(window.location.href);
const addCcProps = ReadAddCreditCardProp(window.location.href);
const currentUrl = new URL(window.location.href);

if (currentUrl.pathname == "/health") {
  ReactDOM.render(
    <React.StrictMode>
      <Health />
    </React.StrictMode>,
    document.getElementById("root")
  );
} else if (currentUrl.pathname == "/error") {
  ReactDOM.render(
    <React.StrictMode>
      <CheckoutErrorPage />
    </React.StrictMode>,
    document.getElementById("root")
  );
} else if (currentUrl.pathname.includes("/challengeui")) {
  const pathSegments = currentUrl.pathname.split("/");
  // Default to v1 if "v2" is not present in the URL path
  const version = pathSegments.includes("v2") ? "v2" : "v1";
  const env = getEnvironmentFromUrl(window.location.href);

  // Dynamically import the correct version to enable code splitting
  const ChallengeProtocolPromise = version === "v2"
    ? import("./v2/challengeui/challengeProtocol").then(module => module.ChallengeProtocol)
    : import("./v1/challengeui/challengeProtocol").then(module => module.ChallengeProtocol);

  ChallengeProtocolPromise.then(ChallengeProtocol => {
    ReactDOM.render(
      <React.StrictMode>
        <ChallengeProtocol env={env} />
      </React.StrictMode>,
      document.getElementById("root")
    );
  }).catch((error) => {
    console.error("Failed to load ChallengeProtocol", error);
    ReactDOM.render(
      <React.StrictMode>
        <div>Unable to load challenge</div>
      </React.StrictMode>,
      document.getElementById("root")
    );
  });
} else if (/^\/challenge\/[^/]+$/.test(currentUrl.pathname)) { // matches /challenge/{sessionId}
  const sessionId = currentUrl.pathname.split("/")[2];
  ReactDOM.render(
    <>
      <div id="customHeader"></div>
      <HandleRedirectPaymentChallenge
        sessionId={sessionId}
        env={environment}
      />
      <div id="customFooter"></div>
    </>,
    document.getElementById("root")
  );
  addHeaderFooter();
} else if (/^\/confirm\/?$/.test(currentUrl.pathname)) {
  const consentProps = readRdsConsentProps(currentUrl);
  ReactDOM.render(
    <div className="rds-consent-shell">
      <div id="customHeader"></div>
      <RdsConsentPage
        email={consentProps.email}
        env={consentProps.env}
        greenId={consentProps.greenId}
        sessionId={consentProps.sessionId}
      />
      <div id="customFooter"></div>
    </div>,
    document.getElementById("root")
  );
  addHeaderFooter();
} else if (/^\/fingerprint\/?$/.test(currentUrl.pathname)) {
  const fingerprintProps = readDeviceFingerprintProps(currentUrl);
  ReactDOM.render(
    <DeviceFingerprintPage
      env={fingerprintProps.env}
      greenId={fingerprintProps.greenId}
      sessionId={fingerprintProps.sessionId}
    />,
    document.getElementById("root")
  );
} else if (currentUrl.pathname.includes("/addCard")) {
  addHeaderFooter();
  ReactDOM.render(
    <React.StrictMode>
      <body>
          <div id="customHeader"></div>
          {/* generate the green id, send it to risk to fingerprint (it will be javascript) and pass that along */}
          <main>
          <AddCreditCard
            env={addCcProps.env}
            sessionId={addCcProps.sessionId}
            country={addCcProps.country}
            language={addCcProps.language}
            partner={addCcProps.partner}
            paymentType={addCcProps.paymentType}
            paymentFamily={addCcProps.paymentFamily}
            scenario={addCcProps.scenario}
          />
          </main>
          <div id="customFooter"></div>
      </body>
    </React.StrictMode>,
    document.getElementById("root")
  );
} else {
  // The 3rd-party guest-checkout route (/payment-providers/{provider}/checkout(s)/{id}/start)
  // has been discontinued. Any URL that doesn't match the routes above renders 404.
  ReactDOM.render(
    <React.StrictMode>
      <div>404 Not Found :(</div>
    </React.StrictMode>,
    document.getElementById("root")
  );
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

function addHeaderFooter () {
  <script src="http://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js"></script>

  $(document).ready(function() {
    $.ajax({
      url: "https://uhf.microsoft.com/us/shell/xml/MSPayCard?headerid=MSPayCardHeader&footerid=MSPayCardFooter",
      method: 'GET',
      dataType: "xml",
    }).done((msg) => {
      const responsexml = msg;
      const cssIncludes = $(responsexml).find("cssIncludes")[0].childNodes[1] as CDATASection;
      const trimCssData = cssIncludes.data.trim();
      const styles = $.parseHTML(trimCssData);
      $("head").append(styles);

      const headerHtml = ($(responsexml).find("headerHtml")[0].childNodes[1] as CDATASection).data.trim();
      (document.getElementById("customHeader") as HTMLFormElement).innerHTML = headerHtml;

      const footerHtml = ($(responsexml).find("footerHtml")[0].childNodes[1] as CDATASection).data.trim();
      (document.getElementById("customFooter") as HTMLFormElement).innerHTML = footerHtml;

      const javascriptIncludes = ($(responsexml).find("javascriptIncludes")[0].childNodes[1] as CDATASection).data.trim();
      const scriptContainer = document.createElement("div");
      scriptContainer.innerHTML = javascriptIncludes;

      const sourceScripts = Array.from(scriptContainer.querySelectorAll("script"));
      const hasModuleScript = sourceScripts.some(
        (script) => script.getAttribute("type")?.trim().toLowerCase() === "module"
      );

      // UHF 1.0 scripts were historically ignored; only materialize a UHF 1.1 module payload.
      if (!hasModuleScript) {
        return;
      }

      sourceScripts.forEach((sourceScript) => {
        const script = document.createElement("script");

        Array.from(sourceScript.attributes).forEach((attribute) => {
          script.setAttribute(attribute.name, attribute.value);
        });

        if (!sourceScript.hasAttribute("async")) {
          script.async = false;
        }

        script.textContent = sourceScript.textContent;
        document.head.appendChild(script);
      });
    });
  });
}

function ReadAddCreditCardProp(href: string): IAddCreditCardProps {
  // href example:
  //  https://pay.microsoft.com/anonymous?sessionId=6b1457bf-08cf-44a4-bc52-3028113df9d8&country=us&language=en-us&parnter=xboxsettings

  const parts = href.split("/");
  const queryParams = new URL(href).searchParams;
  const language = queryParams.get("language") ?? "en-us";
  const country = queryParams.get("country") ?? "us";
  const sessionId = queryParams.get("sessionId") ?? "";
  const partner = queryParams.get("partner") ?? "xboxsettings";
  const paymentType = queryParams.get("type") ?? "amex,visa,mc,discover";
  const paymentFamily = queryParams.get("paymentFamily") ?? "credit_card";
  const scenario = queryParams.get("scenario") ?? "secondScreenAddPi";

  const env = getEnvironmentFromUrl(href);

  return {
    country: country,
    env: env,
    language: language,
    sessionId: sessionId,
    partner: partner,
    paymentType: paymentType,
    paymentFamily: paymentFamily,
    scenario: scenario,
  };
}

function getEnvironmentFromUrl(href: string): string {
  let env = "int";
  switch (new URL(href).hostname) {
    case "payint.microsoft.com":
      env = "int";
      break;
    case "payppe.microsoft.com":
      env = "ppe";
      break;
    case "pay.microsoft.com":
      env = "prod";
      break;
  }

  return env;
}
function readRdsConsentProps(url: URL): IRdsConsentPageProps {
  return {
    email: url.searchParams.get("email") || "",
    env: getEnvironmentFromUrl(url.href),
    greenId: url.searchParams.get("greenId") || "",
    sessionId: url.searchParams.get("sessionId") || "",
  };
}

function readDeviceFingerprintProps(url: URL): IDeviceFingerprintPageProps {
  return {
    env: getEnvironmentFromUrl(url.href),
    greenId: url.searchParams.get("greenId") || "",
    sessionId: url.searchParams.get("sessionId") || "",
  };
}
